<template>
    <div id="drug-item-inventory-item-container">
        <b-row>
            <b-col>
                <MdTitle 
                    v-bind:Text="this.editMode ? $t('DrugInventoryItem.EditTitle'): $t('Shared.AddTitle')"
                />
            </b-col>
        </b-row>

        <b-row>
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('Shared.Code')"
                    v-bind:Name="'Code'"
                    v-bind:TypeProp="'text'"  
                    v-bind:MaxLengthProp="15"     
                    v-model="itemEditable.itemcode"
                    v-bind:isReadOnly="isReadOnly || !isEditable || editMode"
                    v-bind:Id="'input_code'"
                    v-bind:isRequired="true"
                    v-bind:isValid="isCodeValid"
                /> 
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('Shared.Description')"
                    v-bind:Name="'Description'"
                    v-bind:TypeProp="'text'"  
                    v-bind:MaxLengthProp="500"         
                    v-model="itemEditable.description"
                    v-bind:isReadOnly="isReadOnly || !isEditable"
                    v-bind:Id="'input_description'"
                    v-bind:isRequired="true"
                    v-bind:isValid="isDescriptionValid"
                /> 
            </b-col>
             <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('DrugInventoryItem.DispensingQty')"
                    v-bind:Name="'DispensingQty'"
                    v-bind:TypeProp="'number'"
                    v-bind:Min="'1'"
                    v-bind:StepProp="'1'"  
                    v-model.number="itemEditable.dispensingQty"
                    v-bind:isReadOnly="isReadOnly || !isEditable"
                    v-bind:Id="'input_DispensingQty'"
                /> 
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('DrugInventoryItem.DispensingCapacity')"
                    v-bind:Name="'DispensingCapacity'"
                    v-bind:TypeProp="'number'"
                    v-bind:Min="'0.01'"
                    v-bind:StepProp="'0.01'"
                    v-model="itemEditable.dispensingCapacity"
                    v-bind:isReadOnly="isReadOnly || !isEditable"
                    v-bind:Id="'input_DispensingCapacity'"
                /> 
            </b-col>
        </b-row>

        <b-row>           
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('DrugInventoryItem.DispensingUOM')"
                    v-bind:Name="'DispensingUOM'"
                    v-bind:TypeProp="'text'" 
                    v-bind:MaxLengthProp="10"      
                    v-model="itemEditable.dispensinguom"
                    v-bind:isReadOnly="isReadOnly || !isEditable"
                    v-bind:Id="'input_DispensingUOM'"
                /> 
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('DrugInventoryItem.PurchaseUOM')"
                    v-bind:Name="'PurchaseUOM'"
                    v-bind:TypeProp="'text'"
                    v-bind:MaxLengthProp="10"       
                    v-model="itemEditable.purchaseuom"
                    v-bind:isReadOnly="isReadOnly || !isEditable"
                    v-bind:Id="'input_PurchaseUOM'"
                /> 
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('DrugInventoryItem.PurchaseQuantity')"
                    v-bind:Name="'PurchaseQuantity'"
                    v-bind:TypeProp="'number'"
                    v-bind:Min="'1'"
                    v-bind:StepProp="'1'"
                    v-model.number="itemEditable.unitineach"
                    v-bind:isReadOnly="isReadOnly || !isEditable"
                    v-bind:Id="'input_PurchaseQuantity'"
                /> 
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('DrugInventoryItem.UnitCost')"
                    v-bind:Name="'UnitCost'"
                    v-bind:TypeProp="'number'"
                    v-bind:Min="'0.01'"
                    v-bind:StepProp="'0.01'"
                    v-model="itemEditable.dispensingunitcost"
                    v-bind:isReadOnly="isReadOnly || !isEditable"
                    v-bind:Id="'input_UnitCost'"
                /> 
            </b-col>
        </b-row>

        <b-row>            
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="isNRC ? $t('DrugInventoryItem.UnitPublishedPrice') : $t('Shared.UnitPrice')"
                    v-bind:Name="'UnitPrice'"
                    v-bind:TypeProp="'number'"
                    v-bind:Min="'0.01'"
                    v-bind:StepProp="'0.01'"
                    v-model="itemEditable.dispensingunitprice"
                    v-bind:isReadOnly="isReadOnly || !isEditable"
                    v-bind:Id="'input_UnitPrice'"
                /> 
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('DrugInventoryItem.PurchasePrice')"
                    v-bind:Name="'PurchasePrice'"
                    v-bind:TypeProp="'number'"
                    v-bind:Min="'0.01'"
                    v-bind:StepProp="'0.01'"
                    v-model="itemEditable.cost"
                    v-bind:isReadOnly="isReadOnly || !isEditable"
                    v-bind:Id="'input_PurchasePrice'"
                /> 
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('DrugInventoryItem.MinReorderLevel')"
                    v-bind:Name="'MinReorderLevel'"
                    v-bind:TypeProp="'number'"
                    v-bind:Min="'1'"
                    v-bind:StepProp="'1'"
                    v-model.number="itemEditable.minreorderlevel"
                    v-bind:isReadOnly="isReadOnly || !isEditable"
                    v-bind:Id="'input_MinReorderLevel'"
                /> 
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('DrugInventoryItem.MinOrderQTY')"
                    v-bind:Name="'MinOrderQTY'"
                    v-bind:TypeProp="'number'"
                    v-bind:Min="'1'"
                    v-bind:StepProp="'1'"
                    v-model.number="itemEditable.minorderqty"
                    v-bind:isReadOnly="isReadOnly || !isEditable"
                    v-bind:Id="'input_MinOrderQTY'"
                /> 
            </b-col>
        </b-row>

        <b-row>            
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('DrugInventoryItem.NoDaysNotify')"
                    v-bind:Name="'NoDaysNotify'"
                    v-bind:TypeProp="'number'"
                    v-bind:Min="'1'"
                    v-bind:StepProp="'1'"
                    v-model.number="itemEditable.daysNotifyBeforeExpire"
                    v-bind:isReadOnly="isReadOnly || !isEditable"
                    v-bind:Id="'input_NoDaysNotify'"
                /> 
            </b-col>
            
            <b-col lg="3" md="3" sm="12">
                <MdLookup
                    v-bind:Label="$t('DrugInventoryItem.ItemCategory')"
                    v-bind:ModelCode="itemEditable.category"
                    v-bind:ModelDescription="categoryName"
                    v-bind:RefCode="'ItemCategory'"
                    v-bind:IsDisabled="isReadOnly || !isEditable"
                    v-bind:Api="'ItemCategories'"
                    v-bind:FieldCode="'categoryCode'"
                    v-bind:Fields="BaseFields" 
                    v-bind:FieldDescription="'description'"
                    :SearchTitle="$t('DrugInventoryItem.ItemCategory')"
                    :GetValues="onChangeLookup"
                    :SearchFieldCode="'Code'"
                    v-bind:Tag="'ItemCategory'"         
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdLookup
                    v-bind:Label="$t('DrugInventoryItem.CPTCode')"
                    v-bind:ModelCode="itemEditable.cptcode"
                    v-bind:ModelDescription="cptName"
                    v-bind:RefCode="'CPTCode'"
                    v-bind:IsDisabled="isReadOnly || !isEditable"
                    v-bind:Api="'CPTs'"
                    v-bind:FieldCode="'code'"
                    v-bind:Fields="BaseFieldsCPT"
                    v-bind:FieldDescription="'name'"
                    :SearchTitle="$t('DrugInventoryItem.CPTCode')"
                    :GetValues="onChangeLookup"
                    :SearchFieldCode="'Code'"
                    v-bind:isRequired="true"
                    v-bind:Tag="'CPTCode'"        
                    v-bind:isValid="isCptCodeValid"
                />
            </b-col>
             <b-col lg="3" md="3" sm="12">
                <MdLookup
                    v-bind:Label="$t('Shared.HCPCSCode')"
                    v-bind:ModelCode="itemEditable.hcpcscode"
                    v-bind:ModelDescription="hcpcsName"
                    v-bind:RefCode="'HCPCSCode'"
                    v-bind:IsDisabled="isReadOnly || !isEditable"
                    v-bind:Api="'CPTs'"
                    v-bind:FieldCode="'code'"
                    v-bind:FieldDescription="'name'"
                    v-bind:Fields="BaseFieldsCPT"
                    :SearchTitle="$t('Shared.HCPCSCode')"
                    :GetValues="onChangeLookup"
                    :SearchFieldCode="'Code'" 
                    v-bind:Tag="'HCPCSCode'"         
                />
            </b-col>
        </b-row>

        <b-row> 
            <b-col lg="3" md="3" sm="12">
                <MdLookup
                    v-bind:Label="$t('DrugInventoryItem.Mod')"
                    v-bind:ModelCode="itemEditable.modifier1"
                    v-bind:ModelDescription="modifierName"
                    v-bind:RefCode="'Mod'"
                    v-bind:IsDisabled="isReadOnly || !isEditable"
                    v-bind:Api="'Modifiers'"
                    v-bind:FieldCode="'code'"
                    v-bind:Fields="BaseFieldsMod"
                    v-bind:FieldDescription="'description'"
                    :SearchTitle="$t('DrugInventoryItem.Mod')"
                    :GetValues="onChangeLookup"
                    :SearchFieldCode="'Code'"
                    v-bind:Tag="'Mod'"         
                />
            </b-col>
             <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('DrugInventoryItem.VolumenCapacity')"
                    v-bind:Name="'VolumenCapacity'"
                    v-bind:TypeProp="'number'"
                    v-bind:Min="'0.01'"
                    v-bind:StepProp="'0.01'"
                    v-model="itemEditable.volumenCapacity"
                    v-bind:isReadOnly="isReadOnly || !isEditable"
                    v-bind:Id="'input_VolumenCapacity'"
                /> 
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('DrugInventoryItem.VolumenUnit')"
                    v-bind:Name="'VolumenUnit'"
                    v-bind:TypeProp="'text'"  
                    v-bind:MaxLengthProp="10"      
                    v-model="itemEditable.volumenUnit"
                    v-bind:isReadOnly="isReadOnly || !isEditable"
                    v-bind:Id="'input_VolumenUnit'"
                />                
            </b-col>
             <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('DrugInventoryItem.DohCode')"
                    v-bind:Name="'DohCode'"
                    v-bind:TypeProp="'text'"  
                    v-bind:MaxLengthProp="25"      
                    v-model="itemEditable.invOtherCode"
                    v-bind:isReadOnly="isNRC ? true : false"
                    v-bind:Id="'input_DohCode'"
                /> 
            </b-col>
        </b-row>
        <b-row>
            <b-col md="auto">
                <MdCheckBox
                    v-bind:Label="$t('DrugInventoryItem.IsActive')"
                    v-bind:Name="'IsActive'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="true"
                    v-bind:UncheckedValue="false"
                    v-model="itemEditable.isactive"/>
            </b-col>
            <b-col md="auto">
                <MdCheckBox
                    v-bind:Label="$t('DrugInventoryItem.ShowSigByDosage')"
                    v-bind:Name="'ShowSigByDosage'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="true"
                    v-bind:UncheckedValue="false"
                    v-model="itemEditable.showSigByDosage"/>
            </b-col>
            <b-col md="auto">
                <MdCheckBox
                    v-bind:Label="$t('DrugInventoryItem.IsReusable')"
                    v-bind:Name="'IsReusable'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="true"
                    v-bind:UncheckedValue="false"
                    v-model="itemEditable.isReusable"/>
            </b-col>
        </b-row>

        <b-row v-if="editMode" class="mt-5">
            <b-col>
                <MdTitle 
                    v-bind:Text="$t('DrugInventoryItem.Info')"
                />
            </b-col>
        </b-row>
        
        <b-row v-if="editMode">
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('DrugInventoryItem.LastReceivedDate')"
                    v-bind:Name="'LastReceivedDate'"
                    v-bind:TypeProp="'text'"       
                    v-model="info.lastDateReceived"
                    v-bind:isReadOnly="true"
                    v-bind:Id="'input_LastReceivedDate'"
                /> 
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('DrugInventoryItem.LastPoNumber')"
                    v-bind:Name="'LastPoNumber'"
                    v-bind:TypeProp="'text'"       
                    v-model="info.lastPONumber"
                    v-bind:isReadOnly="true"
                    v-bind:Id="'input_LastPoNumber'"
                /> 
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('DrugInventoryItem.TotalOrdered')"
                    v-bind:Name="'TotalOrdered'"
                    v-bind:TypeProp="'text'"       
                    v-model="info.totalUnitsOrderd"
                    v-bind:isReadOnly="true"
                    v-bind:Id="'input_TotalOrdered'"
                /> 
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('DrugInventoryItem.MaxUnitPrice')"
                    v-bind:Name="'MaxUnitPrice'"
                    v-bind:TypeProp="'text'"       
                    v-model="info.maxUnitPrice"
                    v-bind:isReadOnly="true"
                    v-bind:Id="'input_MaxUnitPrice'"
                /> 
            </b-col>
        </b-row>

        <b-row v-if="editMode">
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('DrugInventoryItem.LastOrderedDate')"
                    v-bind:Name="'LastOrderedDate'"
                    v-bind:TypeProp="'text'"       
                    v-model="info.lastDateOrdered"
                    v-bind:isReadOnly="true"
                    v-bind:Id="'input_LastOrderedDate'"
                /> 
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('DrugInventoryItem.LastVendor')"
                    v-bind:Name="'LastVendor'"
                    v-bind:TypeProp="'text'"       
                    v-model="info.vendorCode"
                    v-bind:isReadOnly="true"
                    v-bind:Id="'input_LastVendor'"
                /> 
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('DrugInventoryItem.TotalUsed')"
                    v-bind:Name="'TotalUsed'"
                    v-bind:TypeProp="'text'"       
                    v-model="info.totalUse"
                    v-bind:isReadOnly="true"
                    v-bind:Id="'input_TotalUsed'"
                /> 
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('DrugInventoryItem.TotalAvailable')"
                    v-bind:Name="'TotalAvailable'"
                    v-bind:TypeProp="'text'"       
                    v-model="info.totalAvailable"
                    v-bind:isReadOnly="true"
                    v-bind:Id="'input_TotalAvailable'"
                /> 
            </b-col>
        </b-row>

        <div class="space-actions"></div>
        <div class="page-actions">
            <MdButton
                v-bind:Label="$t('Shared.Back')"
                v-bind:Name="'btnBack'"
                v-bind:TextToolTip="$t('ePharmacyItemsReceived.BackToList')" 
                v-on:click="goBack"
                v-bind:ClassProp="'mx-2 btn-login'"
            />
            <MdButton
                v-bind:Label="$t('Shared.Save')"
                v-bind:ClassProp="(this.isReadOnly)?'primary mx-2':'primary btn-login mx-2'"
                v-on:click="SaveOrEdit"
                v-bind:isReadOnly=this.isReadOnly
                v-bind:Name="'btn_save_inventory_item'"
            />
        </div>
    </div>
</template>

<script>
import ShowMessage from '@/components/messages/ShowMessage.js'
import DBFunctions from '@/common/DBFunctions.js'
import { EventBus } from '@/event-bus.js';
import InventoryItemService from '@/services/inventoryitem.service'
import DrugOrdersInboxService from '@/services/drugordersinbox.service'
import Utils from '@/common/utils.js'

let elemSaveBtn = '';    
export default {
    beforeRouteLeave(to, from, next) {
        if (!this.isReadOnly && this.pendingChanges) {
            this.$bvModal.msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
                title: this.$t('Shared.PatientAllergies'),
                okTitle: this.$t('Shared.BtnSave'),
                cancelTitle: this.$t('Shared.BtnDismiss'),
                footerClass: 'p-2',
                titleClass: 'modal-title modal-type-warning'
            })
            .then(value => {
                if(!value){
                    next();
                } else {
                    this.SaveOrEdit();
                    next();
                }
            })		
        } else {
            next()
        }
    },

    mixins: [ShowMessage, DBFunctions],
    props: {
        editMode: Boolean,
    },
    data() {
        return {
            isNRC:this.$store.state.companies.isNRC,
            BaseFields:[{ key: 'description', sortable: true, label: this.$t('Shared.Description') },{ key: 'categoryCode', sortable: true, label: this.$t('Shared.Code')}],
            BaseFieldsCPT:[{ key: 'name', sortable: true, label: this.$t('Shared.Description') },{ key: 'code', sortable: true, label: this.$t('Shared.Code')},{ key: 'type', sortable: true, label: this.$t('Shared.Type')}],
            BaseFieldsMod:[{ key: 'description', sortable: true, label: this.$t('Shared.Description') },{ key: 'code', sortable: true, label: this.$t('Shared.Code')}],
            OptionsRightMenu:{
                visible:false,
                btnvisible:false,
                ItemsList:[],
                favButtonAtion: false
            }, 

            isReadOnly: false,
            isEditable: true,
            itemEditable: {
                itemcode: null,
                description: null,
                dispensingQty: null,
                dispensingCapacity: null,
                dispensinguom: null,
                purchaseuom: null,
                unitineach: null,
                dispensingunitcost: null,
                dispensingunitprice: null,
                cost: null,
                minreorderlevel: null,
                minorderqty: null,
                daysNotifyBeforeExpire: null,
                invOtherCode: null,
                category: null,
                cptcode: null,
                hcpcscode: null,
                modifier1: null,
                volumenCapacity: null,
                volumenUnit: null,
                isactive: true,
                showSigByDosage: false,
                isReusable: false,
                
            },
            info: {
                lastDateReceived: null,
                lastPONumber: null,
                totalUnitsOrderd: null,
                maxUnitPrice: null,
                lastDateOrdered: null,
                vendorCode: null,
                totalUse: null,
                totalAvailable: null,
            },
            categoryName: '',
            cptName: '',
            hcpcsName: '',
            modifierName: '',
            pendingChanges: false,
            isDescriptionValid: true,
            isCodeValid: true,
            isCptCodeValid: true,    
        }
    },

    methods: {
        goBack() {
            this.$router.push({ name: 'DrugInventoryItems' });
        },

        SaveOrEdit() {
            if(!this.isReadOnly) {
                if (this.validate_required()) {
                    elemSaveBtn.setAttribute("disabled",'');

                    if (this.editMode) { 
                        this.update();
                    } else {            
                        this.save();
                    }
                }  else {
                    this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.CheckRedLabeledFields'), "errorAutoHide");
                }
            }
        },

        save() {
            InventoryItemService
                .add(this.itemEditable)
                .then((response) => {
                    if(response.status == '200'){
                        this.pendingChanges = false;
                        setTimeout(() => 
                            this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                                title: this.$t('Msg.Success'),
                                autoHideDelay: 5000,
                                variant: "success"
                            })
                            , 50); 

                        this.goBack();
                    }
                })
                .catch((error) => {
                    elemSaveBtn.removeAttribute("disabled");
                    this.showResponseErrorMessage(error);
                });
        },

        update() {
            InventoryItemService
                .update(this.$route.params.recId, this.itemEditable)
                .then((response) => {
                    if(response.status == '200'){
                        this.pendingChanges = false;
                        setTimeout(() => 
                            this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                                title: this.$t('Msg.Success'),
                                autoHideDelay: 5000,
                                variant: "success"
                            })
                            , 50); 

                        this.goBack();
                    }
                })
                .catch((error) => {
                    elemSaveBtn.removeAttribute("disabled");
                    this.showResponseErrorMessage(error);
                });
        },

        validate_required() {
            this.isCodeValid = !Utils.isNullOrEmptyString(this.itemEditable.itemcode);
            this.isDescriptionValid = !Utils.isNullOrEmptyString(this.itemEditable.description);
            this.isCptCodeValid = !Utils.isNullOrEmptyString(this.itemEditable.cptcode)
            return this.isDescriptionValid && this.isCodeValid && this.isCptCodeValid;
        },

        onChangeLookup(result) {
            const lookup = result.FieldName;
            if (lookup.indexOf('Mod') !== -1) {
                this.itemEditable.modifier1 = result.code;
                this.modifierName = result.description;
            } else if (lookup.indexOf('HCPCSCode') !== -1) {
                this.itemEditable.hcpcscode = result.code;
                this.hcpcsName = result.description;
            } else if (lookup.indexOf('CPTCode') !== -1) {
                this.itemEditable.cptcode = result.code;
                this.cptName = result.description;
            } else if (lookup.indexOf('ItemCategory') !== -1) {
                this.itemEditable.category = result.code;
                this.categoryName = result.description;
            }
        },

        async getInventoryItemById(code) {
            await InventoryItemService
                        .get(code)
                        .then((response) => {
                            if(response.status == '200') {
                                this.itemEditable = response.data;

                                this.cptName = this.itemEditable.cptDescription
                                this.categoryName = this.itemEditable.categoryDescription;
                                this.hcpcsName = this.itemEditable.hcpcsDescription;
                                this.modifierName = this.itemEditable.modifierDescription;
                                
                               /* this.cptName = this.itemEditable.cptcode;
                                this.categoryName = this.itemEditable.category;
                                this.hcpcsName = this.itemEditable.hcpcscode;
                                this.modifierName = this.itemEditable.modifier1;*/
                            }
                        })
                        .catch(error => {
                            this.showResponseErrorMessage(error);
                        });
        },

        async getInventoryItemInfo(code) {
            await DrugOrdersInboxService
                        .getInventoryItemInfo(code)
                        .then((response) => {
                            if(response.status == '200') {
                                this.info = response.data;
                                this.info.lastDateReceived = Utils.formatterDateToString(this.info.lastDateReceived);
                                this.info.lastDateOrdered = Utils.formatterDateToString(this.info.lastDateOrdered);
                            }
                        })
                        .catch(error => {
                            this.showResponseErrorMessage(error);
                        });
        },

        beforeWindowUnload(e) {
			if (this.pendingChanges) {
				e.preventDefault()
				e.returnValue = ''	
            }
        },

        checkUserAction() {
            if (elemSaveBtn.disabled) {
                elemSaveBtn.removeAttribute('disabled');
            }
        },
    },

    async mounted() {

        this.OptionsRightMenu.visible = false;
        this.OptionsRightMenu.btnDrugOrdersInboxvisible = false;    
        this.OptionsRightMenu.ItemsList = [];
        this.$emit('onMenuRightBarDrugOrdersInbox', this.OptionsRightMenu);
        let layoutStatus = this.$store.state.layoutStatus;
        switch(layoutStatus) {
        case 'L0R1':
            this.OptionsRightMenu.favButtonAtion = true;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
        break;
        case 'L1R0':
        case 'L1R1':
            this.OptionsRightMenu.btnvisible = false;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
        break;
        default:
            this.OptionsRightMenu.favButtonAtion = true;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }  


        if (this.editMode) {
            await this.getInventoryItemInfo(this.$route.params.recId);
            await this.getInventoryItemById(this.$route.params.recId);
        }   

        setTimeout( function() {
            elemSaveBtn = document.getElementById('btn_save_inventory_item');
            elemSaveBtn.setAttribute('disabled','');
        }, 50, this );
    },

    created() {
        EventBus.$on("onChanged", function (e) {       
            this.pendingChanges = e.Changed
            this.checkUserAction();
        }.bind(this));
    
        window.addEventListener('beforeunload', this.beforeWindowUnload)
    },

    beforeDestroy() {
        window.removeEventListener('beforeunload', this.beforeWindowUnload)
    },
}
</script>